import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import ScrollToTop from '../../../components/scrollToTop';
import './thanku.scss';
import { UserLogin, SwitchLayer2, Loading } from '../../../redux/action';
import { useNavigate } from 'react-router-dom';
import { LocalService, LoginService, PublicService } from '../../../core/services';
import useBodyClass from '../../../hooks/useBodyClass';
// import ThankUMessage from './whatsapp-community-message';

const localService = new LocalService();
const loginService = new LoginService();
const publicService: PublicService = new PublicService();

interface Props {
    UserReducer: (data: any) => void;
    SwitchUserData: (data: any) => void;
    switchLayer1: any;
    loading: (data: any) => void;
    activeAccount: any;
}

const ThankuPage: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();
    // const [remember, setRemember] = useState(false);
    // const [loading, setLoading] = useState(false);
    // const [login, setLogin] = useState({ logIn: '', password: '', pin: '' });
    // const [activeAccount, setActiveAccount] = useState<any>(null);
    const [activeAccount, setActiveAccount] = useState<any>(props.switchLayer1 ? props.switchLayer1[0] : null);

    // Get user-id from URL
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') || '';
    const url = window.location.href || '';

    useEffect(() => {
        // if (localService.getStorageItem('login') && localService.getStorageItem('password')) {
        //     const _Login = localService.getStorageItem('login') || '';
        //     const _Pass = localService.getStorageItem('password') || '';
        //     handleLogin(_Login, _Pass, '');
        // }

        // Function to send the POST request
        async function recordFbLeadConversion() {
            if (!id) {
                console.error('No user ID found in URL');
                return;
            }
            try {
                const response = await publicService.recordFbConversionLead({ user_id: id, url: url });
                // console.log('Response:', response);
            } catch (error) {
                console.error('Error sending POST request:', error);
            }
        }

        // Call the function to send the POST request
        recordFbLeadConversion();
    }, [id])

    useEffect(() => {
        // const useractive: any = localService.getStorageItem('userreducer');
        if (props.switchLayer1) {
            try {
                localService.setStorageItem( 'switchaccount',JSON.stringify(props.switchLayer1));
                //   if (props.switchLayer1.length === 1) {
                //     //if Account Length === 1 then Direct Navigate Home Page; (Pending Navigation)
                //     setActiveAccount(props.switchLayer1[0]);
                //   } else {
                //     props.loading(false);
                //   }
                setActiveAccount(props.switchLayer1[0]);
            } catch (error) {
                throw new Error(
                    `useEffect Welcome Influencer Set switchaccount Error ==> ${JSON.stringify(
                    error
                    )}`
                );
            } finally {
                // props.loading(false);
            }
        } 
        else {
            try {
                const activeUser = JSON.parse(localService.getStorageItem('switchaccount') || '[]')[0];
                if (activeUser) {
                    setActiveAccount(activeUser);
                }
            } catch (error) {
                throw new Error(
                    `useEffect Welcome Influencer Set 2switchaccount Error ==> ${JSON.stringify(
                    error
                    )}`
                );
            } finally {
                // props.loading(false);
            }
        }
    }, [props.switchLayer1]);

    useEffect(() => {
        if (activeAccount) {
            async function get_Brand_Inf_Data() {
                try {
                    let response: any;
                    response = await loginService.getInfluencerAccounts({
                        user_id: activeAccount.user_id,
                        account_id: activeAccount.account_id,
                    });
                    let gcp_profile_image_url = '';
                    if (response.data.rows.length > 0){
                        // To get gcp_profile_image_url for header
                        const gcp_profile_image_urls = response.data.rows.map((row: any) => row.gcp_profile_image_url).filter((url: string) => url !== '') ?? ['']
          
                        if (gcp_profile_image_urls.length > 0){
                          gcp_profile_image_url = gcp_profile_image_urls[gcp_profile_image_urls.length - 1]
                        }
                    }
                    if (response.data.status > 0) {
                        const userData = {
                            ...activeAccount,
                            influencer_ids: response.data.rows,
                            influencer_id: response.data.rows[0]?.influencer_id,
                            gcp_profile_image_url: gcp_profile_image_url
                        };
                        props.UserReducer(userData);
                        // navigate(nav.influencer);
                        //without remember me save user Data
                        localService.setStorageItem(
                            'userreducer',
                            JSON.stringify(userData)
                        );
                    } else {
                        localService.toastify(response.data.status.message);
                    }
                } catch (error) {
                    throw new Error(
                        `useEffect Welcome Influencer Set User Error ==> ${JSON.stringify(
                        error
                        )}`
                    );
                } finally {
                    props.loading(false);
                }
            }
            get_Brand_Inf_Data();
        }
    }, [activeAccount]);


    //Login Button Actions
    // const handleLogin = (login: string, password: string, pin: string) => {
    //     try {
    //         //login
    //         // localService.logout()
    //         // sessionStorage.clear();
    //         localStorage.clear();

    //         if (login.length > 0 && (password.length > 0 || pin.length > 0)) {
    //             setLoading(true);
    //             LoginService.login({
    //                 logIn: login.replace(/"/g, ''),
    //                 password: password.replace(/"/g, ''),
    //                 pin: pin.replace(/"/g, ''),
    //             })
    //                 .then((res: any) => {
    //                     if (res.data.status === 1) {
    //                         props.IsUserLogged(res.data.status === 1);
    //                         props.switchLayer1(res.data.rows);
    //                         setActiveAccount(res.data.rows[0]);
    //                         props.loading(false);
    //                         // navigate('/switch/account');
    //                         localService.toastify(
    //                             res.info,
    //                             'success',
    //                             1000
    //                         );

    //                         // Save Remmber me
    //                         handleremember();

    //                     } else {
    //                         localService.toastify(
    //                             res.info,
    //                             'info',
    //                             1000
    //                         );
    //                     }

    //                     setLoading(false);
    //                 })
    //                 .catch((error) => {
    //                     throw new Error(
    //                         'handleOTP in Login :: Failed :: ' + error
    //                     );
    //                 });
    //         } else {
    //             localService.toastify(
    //                 'Valid Email or  Valid Mobile Number is required',
    //                 'error',
    //                 1000
    //             );
    //         }
    //     } catch (error) {
    //         throw new Error(`handleLogin ::: ${error}`);
    //     }
    // };

    // const handleremember = () => {
    //     if (remember) {
    //         localService.setStorageItem('DeviceId', JSON.stringify(login));
    //     }

    // };
    
    useBodyClass('common-thankyou-page');
    return (
        <section className='sec-thanks'>
            <ScrollToTop />
            <div className='container'>
                <div className='sec-thanks-left'>
                    <h3>Welcome to ClanConnect!<br />
                        We're excited to have you here.
                    </h3>
                    {/* <ThankUMessage /> */}
                    {activeAccount && <div>
                        <p style={{ fontWeight: 700 , fontSize: 18}}>
                            Join our Community
                        </p>
                        <p>
                            Want to stay in the loop with our latest campaigns and offers? Join our community!
                        </p>
                        <p> 
                            <a className="" href={activeAccount.env.WHATSAPP_COMMUNITY} target="_blank">Click Here</a>{' '}to join{' '}<strong>WhatsApp</strong>{' '}community
                        </p>
                        <p>
                            <a className="" href={activeAccount.env.TELEGRAM_COMMUNITY} target="_blank">Click Here</a>{' '}to join{' '}<strong>Telegram</strong>{' '}community
                        </p>
                    </div>}
                    <button className='btn btn-primary' onClick={() => navigate('/influencer/dashboard')}>Go to Dashboard</button>
                </div>
            </div>
        </section>
    )
}
const mapStateToProps = (state: any) => {
    return {
        switchLayer1: state.SwitchLayer1Reducer.switchAccount,
        activeAccount: state.UserReducer.UserData
    };
};

const mapStateToDispatch = (dispatch: any) => {
    return {
        UserReducer: (data: any) => dispatch(UserLogin(data)),
        SwitchUserData: (data: any) => dispatch(SwitchLayer2(data)),
        loading: (data: any) => dispatch(Loading(data)),
    };
};
const reduxConnect = connect(mapStateToProps, mapStateToDispatch)(ThankuPage);
export { reduxConnect as ThankuPage };
